const KEY_MERCHANT_DEVICE_SN = 'merchantDeviceSn'

export function setMerchantDeviceSn(sn) {
  localStorage.setItem(KEY_MERCHANT_DEVICE_SN, sn)
}

export function getMerchantDeviceSn() {
  return localStorage.getItem(KEY_MERCHANT_DEVICE_SN)
}
